export class Purgatory {
  label;
  interval;
  state = {};
  // when this class was instantiated
  startTime;
  constructor(label = '@nostr/gadgets/purgatory'){
    this.state = JSON.parse(window.localStorage.getItem(label) || '{}');
    this.startTime = Math.round(Date.now() / 1000);
    this.label = label;
    this.interval = setInterval(this.save.bind(this), 60_000);
  }
  close() {
    this.save();
    clearInterval(this.interval);
  }
  save() {
    ;
    this.state.lastSave = Math.round(Date.now() / 1000);
    window.localStorage.setItem(this.label, JSON.stringify(this.state));
  }
  onRelayConnectionFailure(url) {
    const relay = this.state[url] || {
      failures: 0,
      lastAttempt: 0
    };
    relay.failures++;
    relay.lastAttempt = Math.round(Date.now() / 1000);
    this.state[url] = relay;
  }
  onRelayConnectionSuccess(url) {
    delete this.state[url];
  }
  allowConnectingToRelay(url, _operation) {
    if (!url) return false;
    const relay = this.state[url];
    if (!relay) return true;
    let purgeTime = relay.failures * 15 * 60 // 15 minutes for each failure
    ;
    let lastAttempt = relay.lastAttempt < this.startTime ? /* last time was in a previous session. apply the discount */ relay.lastAttempt + this.startTime - this.state.lastSave : relay.lastAttempt;
    if (lastAttempt + purgeTime < Math.round(Date.now() / 1000)) {
      // more time has passed than the required purge time
      return true;
    }
    return false;
  }
}
//# sourceMappingURL=purgatory.js.map